import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';



@Injectable({
  providedIn: 'root'
})



export class HttpService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  httpLogin= {
    headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded'})
  }

  httpOptionsUpload = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'timeout':150000 })
  };

  constructor() { }
}
